import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlockFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.25002 3H8.34002C8.9385 2.99999 9.51231 3.23842 9.93456 3.66254C10.3568 4.08666 10.5927 4.66153 10.59 5.26V8.34C10.59 9.58264 9.58266 10.59 8.34002 10.59H5.25002C4.00738 10.59 3.00002 9.58264 3.00002 8.34V5.26C2.99736 4.66153 3.23324 4.08666 3.65549 3.66254C4.07773 3.23842 4.65155 2.99999 5.25002 3Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.66 3H18.75C19.3485 2.99999 19.9223 3.23842 20.3446 3.66254C20.7668 4.08666 21.0027 4.66153 21 5.26V8.34C21 9.58264 19.9927 10.59 18.75 10.59H15.66C14.4174 10.59 13.41 9.58264 13.41 8.34V5.25C13.41 4.00736 14.4174 3 15.66 3Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.25002 13.41H8.34002C9.58266 13.41 10.59 14.4174 10.59 15.66V18.75C10.59 19.9926 9.58266 21 8.34002 21H5.25002C4.65155 21 4.07773 20.7616 3.65549 20.3375C3.23324 19.9133 2.99736 19.3385 3.00002 18.74V15.66C3.00002 14.4174 4.00738 13.41 5.25002 13.41Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.66 13.41H18.75C19.9927 13.41 21 14.4174 21 15.66V18.74C21.0027 19.3385 20.7668 19.9133 20.3446 20.3375C19.9223 20.7616 19.3485 21 18.75 21H15.66C15.0615 21 14.4877 20.7616 14.0655 20.3375C13.6432 19.9133 13.4074 19.3385 13.41 18.74V15.66C13.41 14.4174 14.4174 13.41 15.66 13.41Z",
			fill: "currentColor"
		})
	]
});
export default SvgBlockFill;
